import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b2503ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-content mt-2 grid grid-cols-12" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bar bg-primary-100 col-span-1 rounded w-2" }, null, -1))
const _hoisted_3 = { class: "items relative col-span-11 justify-self-auto" }
const _hoisted_4 = { class: "flex justify-between items-center pl-8 pr-8 cursor-pointer select-none tab-label bg-white rounded-lg secondary mt-2" }
const _hoisted_5 = { class: "text-grey-darkest pt-4 pb-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rounded-full w-7 h-7 flex items-center justify-center test" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  "data-reactid": "266",
  fill: "none",
  height: "24",
  stroke: "#606F7B",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewbox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("polyline", { points: "6 9 12 15 18 9" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createBlock(_component_router_link, {
        to: _ctx.link,
        key: _ctx.key
      }, {
        default: _withCtx(() => [
          _createElementVNode("header", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.text), 1),
            _hoisted_6,
            _hoisted_7
          ])
        ]),
        _: 1
      }, 8, ["to"]))
    ])
  ]))
}